import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
import { toast } from 'react-toastify';
import ApiBaseURL from '../ApiBaseUrl/ApiBaseURL';
import { useNavigate } from 'react-router-dom';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DashboardInActiveVehicleTypeDetails = ({
    vehicleTypeId = null,
    vendorId = null,
    driverId = null,
    vehicleId = null,
    period = null
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedRange, setSelectedRange] = useState(period);
    const [vehicleData, setVehicleData] = useState([]);

    const navigate = useNavigate();

    const filterOptions = ['Today', 'Yesterday', 'Week', '1M', '3M', '6M'];

    const handleFilterSelect = (range) => {
        setSelectedRange(range);
        setShowDropdown(false);
    };

    const fetchInactiveVehicles = async () => {
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');

        if (!userId || !token) {
            toast.error('Missing userId or token');
            return;
        }

        try {
            const resp = await fetch(`${ApiBaseURL}/dashboard/v1/get/inactive-vehicles-by-type`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    userId,
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    vehicleTypeId,
                    vendorId,
                    driverId,
                    vehicleId,
                    // period: selectedRange
                    period
                })
            });

            const result = await resp.json();

            if (resp.ok && result.statusDescription.statusCode === 200) {
                setVehicleData(result.data || []);
            } else if ([401, 403].includes(result.statusDescription.statusCode)) {
                toast.error(result.statusDescription.description || "Unauthorized access. Redirecting...");
                localStorage.clear();

                setTimeout(() => {
                    window.location.replace('/');
                }, 1500);
            } else {
                console.log(result.statusDescription.description || 'Failed to fetch data');
            }
        } catch (error) {
            toast.error('Error fetching inactive vehicle data: ' + error.message);
        }
    };

    useEffect(() => {
        fetchInactiveVehicles();
    }, [vehicleTypeId, vendorId, driverId, vehicleId, selectedRange]);

    const labels = vehicleData.map(item => item.vehicleType || 'Unknown');
    const values = vehicleData.map(item => item.inactiveCount || 0);

    const chartData = {
        labels,
        datasets: [
            {
                label: 'Inactive Vehicles',
                data: values,
                backgroundColor: [
                    'rgba(255, 99, 132, 0.7)',
                    'rgba(255, 159, 64, 0.7)',
                    'rgba(255, 206, 86, 0.7)',
                    'rgba(153, 102, 255, 0.7)',
                    'rgba(201, 203, 207, 0.7)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(255, 159, 64, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(201, 203, 207, 1)'
                ],
                borderWidth: 1,
            }
        ]
    };

    const options = {
        responsive: true,
        cutout: '60%',
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 20,
                    padding: 15,
                },
            },
            datalabels: {
                color: '#000',
                formatter: (value, context) => {
                    const dataset = context.chart.data.datasets[0].data;
                    const total = dataset.reduce((acc, val) => acc + val, 0);
                    if (!total) return '0%';
                    const percentage = ((value / total) * 100).toFixed(1) + '%';
                    return percentage;
                },
                font: {
                    weight: 'bold',
                    size: 12
                }
            }
        }
    };

    return (
        <div className="card shadow-sm" style={{ maxWidth: '400px' }}>
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="card-title mb-0">Inactive Vehicles</h5>
                    <div style={{ position: 'relative' }}>
                        <i
                            className="fa-solid fa-filter"
                            style={{ cursor: 'pointer', fontSize: '16px' }}
                            onClick={() => setShowDropdown(!showDropdown)}
                        ></i>
                        {showDropdown && (
                            <div
                                className="dropdown-menu show"
                                style={{ position: 'absolute', right: 0, zIndex: 999 }}
                            >
                                {filterOptions.map((range) => (
                                    <button
                                        key={range}
                                        className="dropdown-item"
                                        onClick={() => handleFilterSelect(range)}
                                    >
                                        {range}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div style={{ height: '280px', width: '280px', margin: 'auto' }}>
                    <Doughnut data={chartData} options={options} />
                </div>
            </div>
        </div>
    );
};

export default DashboardInActiveVehicleTypeDetails;